import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/review/$token/")({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
